module.exports = __webpack_public_path__ + "static/media/Waiting.03301dbe.svg";